import { makeLegacyAccessService } from "./accessServiceUtils";

export const creatorPopAccessService = makeLegacyAccessService({
  contentType: "pop",
  itemsKey: "pops",
  grantIdsKey: "popIds",
});
